var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "94px",
    viewBox: "0 0 128 94",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.3---legalsite---confirmation",
    transform: "translate(-657.000000, -387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmation-message",
    transform: "translate(374.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(284.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,55.2212389 C115,24.7239292 90.375125,0 60,0 C29.624875,0 5,24.7239292 5,55.2212389 C5,63.3470442 6.76275,71.0545487 9.9005,78 L110.0995,78 C113.23725,71.0545487 115,63.3470442 115,55.2212389",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,78 L3,78",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,78 L119,78",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,78 L113,78",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,68 C66,69.6571429 52.7914921,71 36.5,71 C20.2066349,71 7,69.6571429 7,68 C7,66.3428571 20.2066349,65 36.5,65 C52.7914921,65 66,66.3428571 66,68",
    id: "Fill-9",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L72.9925241,4.66481481 C72.9925241,2.08888889 70.8843288,0 68.2827261,0 L4.70792903,0 C2.10819529,0 0,2.08888889 0,4.66481481 L0.00747586984,42 L73,42 Z",
    id: "Fill-11",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45488654,42 L52,0 L4.7255673,0 C2.11609365,0 0,2.08888889 0,4.66481481 L0.00750387821,42 L9.45488654,42 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L73,51.3333333 C73,53.9111111 70.8915888,56 68.2878505,56 L4.70841121,56 C2.10841121,56 0,53.9111111 0,51.3333333 L0,42 L73,42 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L73,51.3333333 C73,53.9111111 70.8915888,56 68.2878505,56 L4.70841121,56 C2.10841121,56 0,53.9111111 0,51.3333333 L0,42 L73,42 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,49.5 C39,50.8809524 37.8829365,52 36.5,52 C35.1190476,52 34,50.8809524 34,49.5 C34,48.1210317 35.1190476,47 36.5,47 C37.8829365,47 39,48.1210317 39,49.5",
    id: "Fill-19",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,49.5 C39,50.8809524 37.8829365,52 36.5,52 C35.1190476,52 34,50.8809524 34,49.5 C34,48.1210317 35.1190476,47 36.5,47 C37.8829365,47 39,48.1210317 39,49.5 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "48 66 24 66 25.2 57 46.8 57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "48 66 24 66 25.2 57 46.8 57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,66 L55,66",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L72.9925241,4.66481481 C72.9925241,2.08888889 70.8843288,0 68.2827261,0 L4.70792903,0 C2.10819529,0 0,2.08888889 0,4.66481481 L0.00747586984,42 L73,42 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(44.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4617691,51 L3.53823088,51 C1.5922039,51 0,49.3935927 0,47.4302059 L0,12 L59,12 L59,47.4302059 C59,49.3935927 57.4077961,51 55.4617691,51",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4617691,51 L3.53823088,51 C1.5922039,51 0,49.3935927 0,47.4302059 L0,12 L59,12 L59,47.4302059 C59,49.3935927 57.4077961,51 55.4617691,51 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,12 L0,12 L0,3.47826087 C0,1.56521739 1.5922039,0 3.53823088,0 L55.4617691,0 C57.4077961,0 59,1.56521739 59,3.47826087 L59,12 Z",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,12 L0,12 L0,3.47826087 C0,1.56521739 1.5922039,0 3.53823088,0 L55.4617691,0 C57.4077961,0 59,1.56521739 59,3.47826087 L59,12 Z",
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 C8,7.10434783 7.10434783,8 6,8 C4.89565217,8 4,7.10434783 4,6 C4,4.89565217 4.89565217,4 6,4 C7.10434783,4 8,4.89565217 8,6",
    id: "Fill-35",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 C8,7.10434783 7.10434783,8 6,8 C4.89565217,8 4,7.10434783 4,6 C4,4.89565217 4.89565217,4 6,4 C7.10434783,4 8,4.89565217 8,6 Z",
    id: "Stroke-37",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C16,7.10434783 15.1043478,8 14,8 C12.8956522,8 12,7.10434783 12,6 C12,4.89565217 12.8956522,4 14,4 C15.1043478,4 16,4.89565217 16,6",
    id: "Fill-39",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C16,7.10434783 15.1043478,8 14,8 C12.8956522,8 12,7.10434783 12,6 C12,4.89565217 12.8956522,4 14,4 C15.1043478,4 16,4.89565217 16,6 Z",
    id: "Stroke-41",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,6 C24,7.10434783 23.1043478,8 22,8 C20.8956522,8 20,7.10434783 20,6 C20,4.89565217 20.8956522,4 22,4 C23.1043478,4 24,4.89565217 24,6",
    id: "Fill-43",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,6 C24,7.10434783 23.1043478,8 22,8 C20.8956522,8 20,7.10434783 20,6 C20,4.89565217 20.8956522,4 22,4 C23.1043478,4 24,4.89565217 24,6 Z",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,33 L19.4492754,33 C18.6492754,33 18,32.3507246 18,31.5507246 L18,26.4492754 C18,25.6492754 18.6492754,25 19.4492754,25 L24.5507246,25 C25.3507246,25 26,25.6492754 26,26.4492754 L26,31.5507246 C26,32.3507246 25.3507246,33 24.5507246,33",
    id: "Fill-47",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,33 L19.4492754,33 C18.6492754,33 18,32.3507246 18,31.5507246 L18,26.4492754 C18,25.6492754 18.6492754,25 19.4492754,25 L24.5507246,25 C25.3507246,25 26,25.6492754 26,26.4492754 L26,31.5507246 C26,32.3507246 25.3507246,33 24.5507246,33 Z",
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,33 L33.4492754,33 C32.6492754,33 32,32.3507246 32,31.5507246 L32,26.4492754 C32,25.6492754 32.6492754,25 33.4492754,25 L38.5507246,25 C39.3507246,25 40,25.6492754 40,26.4492754 L40,31.5507246 C40,32.3507246 39.3507246,33 38.5507246,33",
    id: "Fill-51",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,33 L33.4492754,33 C32.6492754,33 32,32.3507246 32,31.5507246 L32,26.4492754 C32,25.6492754 32.6492754,25 33.4492754,25 L38.5507246,25 C39.3507246,25 40,25.6492754 40,26.4492754 L40,31.5507246 C40,32.3507246 39.3507246,33 38.5507246,33 Z",
    id: "Stroke-53",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,33 L46.4492754,33 C45.6492754,33 45,32.3507246 45,31.5507246 L45,26.4492754 C45,25.6492754 45.6492754,25 46.4492754,25 L51.5507246,25 C52.3521739,25 53,25.6492754 53,26.4492754 L53,31.5507246 C53,32.3507246 52.3521739,33 51.5507246,33",
    id: "Fill-55",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,33 L46.4492754,33 C45.6492754,33 45,32.3507246 45,31.5507246 L45,26.4492754 C45,25.6492754 45.6492754,25 46.4492754,25 L51.5507246,25 C52.3521739,25 53,25.6492754 53,26.4492754 L53,31.5507246 C53,32.3507246 52.3521739,33 51.5507246,33 Z",
    id: "Stroke-57",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,45 L19.4492754,45 C18.6492754,45 18,44.3507246 18,43.5507246 L18,38.4492754 C18,37.6492754 18.6492754,37 19.4492754,37 L24.5507246,37 C25.3507246,37 26,37.6492754 26,38.4492754 L26,43.5507246 C26,44.3507246 25.3507246,45 24.5507246,45",
    id: "Fill-59",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,45 L19.4492754,45 C18.6492754,45 18,44.3507246 18,43.5507246 L18,38.4492754 C18,37.6492754 18.6492754,37 19.4492754,37 L24.5507246,37 C25.3507246,37 26,37.6492754 26,38.4492754 L26,43.5507246 C26,44.3507246 25.3507246,45 24.5507246,45 Z",
    id: "Stroke-61",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,45 L33.4492754,45 C32.6492754,45 32,44.3507246 32,43.5507246 L32,38.4492754 C32,37.6492754 32.6492754,37 33.4492754,37 L38.5507246,37 C39.3507246,37 40,37.6492754 40,38.4492754 L40,43.5507246 C40,44.3507246 39.3507246,45 38.5507246,45",
    id: "Fill-63",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,45 L33.4492754,45 C32.6492754,45 32,44.3507246 32,43.5507246 L32,38.4492754 C32,37.6492754 32.6492754,37 33.4492754,37 L38.5507246,37 C39.3507246,37 40,37.6492754 40,38.4492754 L40,43.5507246 C40,44.3507246 39.3507246,45 38.5507246,45 Z",
    id: "Stroke-65",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,45 L46.4492754,45 C45.6492754,45 45,44.3507246 45,43.5507246 L45,38.4492754 C45,37.6492754 45.6492754,37 46.4492754,37 L51.5507246,37 C52.3521739,37 53,37.6492754 53,38.4492754 L53,43.5507246 C53,44.3507246 52.3521739,45 51.5507246,45",
    id: "Fill-67",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,45 L46.4492754,45 C45.6492754,45 45,44.3507246 45,43.5507246 L45,38.4492754 C45,37.6492754 45.6492754,37 46.4492754,37 L51.5507246,37 C52.3521739,37 53,37.6492754 53,38.4492754 L53,43.5507246 C53,44.3507246 52.3521739,45 51.5507246,45 Z",
    id: "Stroke-69",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5507246,20 L7.44927536,20 C6.64927536,20 6,19.3507246 6,18.5507246 L6,17.4492754 C6,16.6492754 6.64927536,16 7.44927536,16 L12.5507246,16 C13.3507246,16 14,16.6492754 14,17.4492754 L14,18.5507246 C14,19.3507246 13.3507246,20 12.5507246,20",
    id: "Fill-71",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5507246,20 L7.44927536,20 C6.64927536,20 6,19.3507246 6,18.5507246 L6,17.4492754 C6,16.6492754 6.64927536,16 7.44927536,16 L12.5507246,16 C13.3507246,16 14,16.6492754 14,17.4492754 L14,18.5507246 C14,19.3507246 13.3507246,20 12.5507246,20 Z",
    id: "Stroke-73",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5080989,20 L19.4919011,20 C18.6683717,20 18,19.3507246 18,18.5507246 L18,17.4492754 C18,16.6492754 18.6683717,16 19.4919011,16 L51.5080989,16 C52.3331202,16 53,16.6492754 53,17.4492754 L53,18.5507246 C53,19.3507246 52.3331202,20 51.5080989,20",
    id: "Fill-75",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5080989,20 L19.4919011,20 C18.6683717,20 18,19.3507246 18,18.5507246 L18,17.4492754 C18,16.6492754 18.6683717,16 19.4919011,16 L51.5080989,16 C52.3331202,16 53,16.6492754 53,17.4492754 L53,18.5507246 C53,19.3507246 52.3331202,20 51.5080989,20 Z",
    id: "Stroke-77",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,25 L14,25",
    id: "Stroke-79",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,29 L14,29",
    id: "Stroke-81",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,33 L14,33",
    id: "Stroke-83",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,37 L14,37",
    id: "Stroke-85",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,41 L14,41",
    id: "Stroke-87",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,45 L11,45",
    id: "Stroke-89",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1392802,67.1655474 C71.8446758,68.2438535 71.252521,68.282154 70.8223986,67.2509869 L64.1555015,51.2502205 C63.7253791,50.2175804 64.2188414,49.7255664 65.2499568,50.1557104 L81.2499207,56.8229419 C82.2825091,57.2530859 82.2442105,57.8437973 81.1644854,58.1398895 L76.0339501,59.5378574 C74.9556981,59.8324766 73.8317824,60.9564487 73.538651,62.0347548 L72.1392802,67.1655474 Z",
    id: "Fill-91",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1392802,67.1655474 C71.8446758,68.2438535 71.252521,68.282154 70.8223986,67.2509869 L64.1555015,51.2502205 C63.7253791,50.2175804 64.2188414,49.7255664 65.2499568,50.1557104 L81.2499207,56.8229419 C82.2825091,57.2530859 82.2442105,57.8437973 81.1644854,58.1398895 L76.0339501,59.5378574 C74.9556981,59.8324766 73.8317824,60.9564487 73.538651,62.0347548 L72.1392802,67.1655474 Z",
    id: "Stroke-93",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration2);
export default __webpack_public_path__ + "static/media/Illustration2.547f7b085da5b0843610f34aceff5779.svg";
export { ForwardRef as ReactComponent };